/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    MarketListQuery,
    MarketListQueryFromJSON,
    MarketListQueryToJSON,
    MarketListResponse,
    MarketListResponseFromJSON,
    MarketListResponseToJSON,
} from '../models';

export interface ApiMarketListDataPostRequest {
    marketListQuery?: MarketListQuery;
}

/**
 * no description
 */
export class MarketListApi extends runtime.BaseAPI {

    /**
     */
    async apiMarketListDataPostRaw(requestParameters: ApiMarketListDataPostRequest): Promise<runtime.ApiResponse<MarketListResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarketList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarketListQueryToJSON(requestParameters.marketListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MarketListResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiMarketListDataPost(requestParameters: ApiMarketListDataPostRequest): Promise<MarketListResponse> {
        const response = await this.apiMarketListDataPostRaw(requestParameters);
        return await response.value();
    }

}
